import React from 'react';
import { Upload, Icon, message } from 'antd';
import downloadIcon from "../../assets/img/download.svg"

function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}

function beforeUpload(file) {
  const isValidType =
    file.type === 'image/jpeg' ||
    file.type === 'image/png' ||
    file.type === 'application/pdf';

  if (!isValidType) {
    message.error('You can only upload JPG/JPEG/PNG/PDF file!');
  }

  const isLt1MB = file.size / 1024 / 1024 < 1;
  if (!isLt1MB) {
    message.error('Image/PDF must be smaller than 1MB!');
  }

  return isValidType && isLt1MB;
}

class AadhaarAvatar extends React.Component {
  state = {
    loading: false,
    imageUrl: this.props.srcImage || '',
    fileName: '', // original file name (e.g., "doc.pdf")
  };

  componentDidMount() {
    const { srcImage } = this.props;
    if (srcImage) {
      const fileName = this.props.isScribe ? "Disability Certificate" : "Aadhaar";
      this.setState({ fileName });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.srcImage !== this.props.srcImage) {
      const fileName = this.props.isScribe ? "Disability Certificate" : "Aadhaar";
      this.setState({
        imageUrl: this.props.srcImage,
        fileName,
      });
    }
  }
  

  getFileNameFromUrl(url) {
    try {
      const parsedUrl = new URL(url, window.location.origin);
      // return parsedUrl.pathname.split('/').pop();
      return parsedUrl.pathname
    } catch (e) {
      console.error('Invalid URL:', e);
      return '';
    }
  }

  handleChange = (info) => {
    if (info.file.status === 'uploading') {
      this.setState({ loading: true });
      return;
    }

    if (!info.file.originFileObj) return;

    //const fileName = info.file.originFileObj.name;
    const fileName = this.props.isScribe ? "Disability Certificate" : "Aadhaar";

    getBase64(info.file.originFileObj, (imageUrl) =>
      this.setState(
        {
          imageUrl,
          fileName,
          loading: false,
        },
        () => {
          this.props.setImage(info.file.originFileObj, imageUrl);
        }
      )
    );
  };

  render() {
    const { imageUrl, fileName, loading } = this.state;

    const uploadButton = (
      <div>
        <Icon type={loading ? 'loading' : 'plus'} />
        <div className="ant-upload-text">
          {this.props.uploadButtonText || 'Upload'}
        </div>
      </div>
    );

    const isPdf = imageUrl && imageUrl.includes('pdf');

    const style = fileName === "Disability Certificate"
      ? {
        marginTop: "10px", marginLeft: "34%"
      }
      : {
        marginTop: "10px", marginLeft: "46%"
      };

    return (
      <div>
        <Upload
          name="avatar"
          listType="picture-card"
          className="avatar-uploader"
          showUploadList={false}
          beforeUpload={beforeUpload}
          onChange={this.handleChange}
          accept=".png,.jpg,.jpeg,.pdf"
        >
          {isPdf ? (
            <div>
              <Icon type="file-pdf" />
              <div className="ant-upload-text">PDF Uploaded</div>
            </div>
          ) : (imageUrl ? <img src={imageUrl} alt="avatar" style={{ width: '500px' }} /> : uploadButton)}
        </Upload>
        {imageUrl !== "" && <a className='pdfBoxAlign' style={style}  target="_blank"  href={imageUrl}> {fileName} <img src={downloadIcon} alt="Download" style={{ marginLeft:"2px" , width: "24px", height: "24px" }} /> </a>}

      </div>


    );
  }
}

export default AadhaarAvatar;
